import { get } from '../../ui/get';
import { theme } from '../../ui/theme';

export const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        boxShadow: state.isFocused
            ? `0px 0px 0px 3px ${theme.colors.focus}, 0px 0px 0px 1px ${theme.colors.border.default}`
            : `0px 1px 1px 0px rgba(25, 54, 67, 0.16), 0px 0px 0px 1px ${theme.colors.border.muted}, 0px 2px 4px 0px rgba(25, 54, 67, 0.08)`,
        border: 'none',
        borderRadius: '6px',
        minHeight: '32px',

        '.highlight &': {
            boxShadow: `0px 0px 0px 3px ${theme.colors.focus}, 0px 0px 0px 1px ${theme.colors.border.default}`,
        },
        '.invalid.dirty &': {
            boxShadow: get('shadows.border.negative'),
        },
        backgroundColor: state.isDisabled ? theme.colors.background.subtle : theme.colors.background.default,
    }),

    placeholder: (provided, state) => ({
        ...provided,
        fontWeight: 'normal',
        margin: '0px 8px',
        color: state.isDisabled ? theme.colors.foreground.disabled : theme.colors.foreground.subtle,
    }),

    singleValue: (provided) => ({
        ...provided,
        fontWeight: 'normal',
        paddingLeft: '8px',
    }),

    input: (provided) => ({
        ...provided,
        paddingLeft: '8px',
        margin: 0,
    }),

    option: (provided, state) => ({
        ...provided,
        padding: '10px 20px',
        borderBottom: '1px solid #DCDFE1',
        color: 'black',
        cursor: 'pointer',
        backgroundColor: state.isFocused ? '#f6f7f7' : 'white',
        '&:hover': {
            backgroundColor: '#f6f7f7',
        },
    }),

    multiValueLabel: (provided) => ({
        ...provided,
        fontWeight: 'normal',
        backgroundColor: theme.colors.background.inset,
        borderRadius: `${theme.radii[1]}px 0px 0px ${theme.radii[1]}px`,
        border: `1px solid ${theme.colors.border.muted}`,
        borderRight: 'none',
        padding: '0px',
        paddingLeft: '4px',
    }),

    multiValueRemove: (provided) => ({
        ...provided,
        fontWeight: 'normal',
        backgroundColor: theme.colors.accent.background,
        borderRadius: `0px ${theme.radii[1]}px ${theme.radii[1]}px 0px`,
        border: `1px solid ${theme.colors.border.muted}`,
        borderLeft: 'none',
        paddingLeft: '4px',
        paddingRight: '4px',

        ':hover': {
            backgroundColor: theme.colors.accent.background,
        },
    }),

    valueContainer: (provided) => ({
        ...provided,
        flexWrap: 'nowrap',
        padding: '2px 4px',
    }),

    indicatorsContainer: (provided) => ({
        ...provided,
        height: '32px',
    }),

    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '4px',
    }),

    menu: (provided) => ({
        ...provided,
        zIndex: 999,
    }),
};
